import loglevel from "loglevel";

export default loglevel.getLogger("torus-embed");
